import '.bo{flex-shrink:0;}.ssr-plugin'
import '.bq{padding:1rem;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.bd{height:100%;}.ssr-plugin'
import '.ay{border:none;}.ssr-plugin'
import '.az{background-color:transparent;}.ssr-plugin'
import '.fw{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.c6{position:sticky;}.ssr-plugin'
import '.fx{top:4rem;}.ssr-plugin'
import '.fy{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fz{padding-bottom:1rem;}.ssr-plugin'
import '.u{margin-bottom:1rem;}.ssr-plugin'
import '.g0{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a6{position:fixed;}.ssr-plugin'
import '.c7{top:0px;}.ssr-plugin'
import '.bb{left:0px;}.ssr-plugin'
import '.bc{right:0px;}.ssr-plugin'
import '.g1{bottom:0px;}.ssr-plugin'
import '.e2{z-index:9999;}.ssr-plugin'
import '.g2{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cr{justify-content:flex-end;}.ssr-plugin'
import '.ce{flex:1;}.ssr-plugin'
import '.af{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bo bq a1 bd ay az fw"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ab"
    >
      <div className="c6 fx fy ae fz u g0 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a6 c7 bb bc g1 e2 ae g2 a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bq a cr g0"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ce af">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
